import React, { useEffect } from "react";
import "./gallery.css";
import { useLocation } from "react-router-dom";
import { useAnimation, useInView } from "framer-motion";
import Footer from "../../components/footer/Footer";
import Navbar from "../../components/navbar/Navbar";
import Helpers from "../../components/helpers/Helpers";
import ReusableGallery from "../../components/reuseableGallery/ReuseableGallery";

const squareVariantsX = {
  visible: { opacity: 1, y: 0, transition: { duration: 2 } },
  hidden: { opacity: 0, y: 100 },
};

const Gallery = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const controls = useAnimation();
  // Sample image arrays - replace with your actual image data
  const graduationImages = [
    { url: Helpers.cultural1, alt: "Graduation ceremony 2024" },
    { url: Helpers.cultural3, alt: "Students receiving certificates" },
    { url: Helpers.cultural4, alt: "Graduation group photo" },
    { url: Helpers.cultural2, alt: "Principal's speech" },
    { url: Helpers.cultural5, alt: "Principal's speech" },
    { url: Helpers.cultural6, alt: "Principal's speech" },
    { url: Helpers.cultural7, alt: "Principal's speech" },

    // Add more graduation images...
  ];

  const outingImages = [
    { url: Helpers.fruit1, alt: "School excursion to museum" },
    { url: Helpers.fruit2, alt: "Students at the zoo" },
    { url: Helpers.fruit3, alt: "Educational field trip" },
    { url: Helpers.fruit4, alt: "Outdoor learning activities" },
    // Add more outing images...
  ];
  return (
    <div className="maxWidthStyle gallery-page">
      <Navbar />

      <div style={{ marginTop: "50px" }} className="gallery-page-header">
        <h1>School Gallery</h1>
        <p>Capturing memorable moments from our school community</p>
      </div>

      {/* Graduation Gallery */}
      <ReusableGallery
        heading="Cultural Day"
        description="Embracing our diverse cultural traditions and promoting unity through colorful displays of Nigerian heritage"
        images={graduationImages}
      />

      {/* Outings Gallery */}
      <ReusableGallery
        heading="Fruit Day Festival"
        description="Promoting healthy eating habits through fun fruit activities and nutrition education"
        images={outingImages}
      />

      <Footer />
    </div>
  );
};

export default Gallery;
